module.exports = __webpack_public_path__ + "static/media/tennis.0f88477e.svg";